export const CHANGE_PROGRESS = 'CHANGE_PROGRESS_ONBOARD_AUS';
export const NEXT_STEP = 'NEXT_STEP_ONBOARD_AUS';
export const PREV_STEP = 'PREV_STEP_ONBOARD_AUS';
export const SET_VALUE_STEP00 = 'SET_VALUE_STEP00_ONBOARD_AUS';
export const SET_VALUE_STEP01 = 'SET_VALUE_STEP01_ONBOARD_AUS';
export const SET_VALUE_STEP01_BUSINESS = 'SET_VALUE_STEP01_ONBOARD_BUSINESS_AUS';
export const SET_VALUE_STEP02 = 'SET_VALUE_STEP02_ONBOARD_AUS';
export const SET_VALUE_STEP03 = 'SET_VALUE_STEP03_ONBOARD_AUS';
export const SET_VALUE_STEP04 = 'SET_VALUE_STEP04_ONBOARD_AUS';
export const SET_VALUE_STEP05 = 'SET_VALUE_STEP05_ONBOARD_AUS';
export const SET_VALUE_STEP06 = 'SET_VALUE_STEP06_ONBOARD_AUS';
export const SET_VALUE_STEP07 = 'SET_VALUE_STEP07_ONBOARD_AUS';

export const SET_VALUE_STEP03_01 = 'SET_VALUE_STEP03_01_ONBOARD_AUS';
export const SET_VALUE_STEP03_02 = 'SET_VALUE_STEP03_02_ONBOARD_AUS';

export const SEARCH_COMPANY_NAME = 'SEARCH_COMPANY_NAME_AUS';
export const SET_STEP01_KEYWORD = 'SET_STEP01_KEYWORD_AUS';
export const SET_COMPANIES_FOUND_VIA_NAME = 'SET_COMPANIES_FOUND_VIA_NAME_AUS';
export const SET_REGISTER_FORM = 'SET_REGISTER_FORM_AUS';

export const SET_IPINFO = 'SET_IPINFO_AUS';
export const SET_PAY_PROVIDER = 'SET_PAY_PROVIDER_AUS';

export const SET_ONBOARD_RESULT = 'SET_ONBOARD_RESULT_AUS';
